import { useWeb3React } from '@web3-react/core'
import { useEffect, useState } from 'react';
import Web3 from 'web3';

function Balance(){
    const {library, account, active} = useWeb3React();
    const [balance, setBalance] = useState();

    useEffect(() => {
        if(library != null){
            getBalance()
        }
    },[library])

    const getBalance = async() => {
        const web3 = new Web3(new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/a6184b6be8424815bdc51ea309e58217"))
        web3.eth.getBalance(account, function(err, result) {
            if (err) {
              console.log(err)
            } else {
                setBalance(web3.utils.fromWei(result, "ether"))
            }
          })
    }
    return(
        <div className='w-40 absolute top-4 left-4'>
            <h1 className='text-white font-bold text-center'>ETH: {balance == null || active == false ? <span className='font-thin ml-1 mr-1'>Not Connected</span>:<span className='font-thin ml-1 mr-1'>{balance}</span>}</h1>
        </div>
    )

}

export default Balance;